import { useLayoutEffect, useEffect, useState, useCallback, useMemo, createElement } from 'react';

var styles = {"wrapper":"_1I_qj","is_state_closed":"_1L6Gs","is_state_open":"_2mqKm","is_revealType_bottomFirst":"_2KsIP","in":"_VrGmt","is_revealType_topFirst":"_3DkiG","is_transitioning":"_12f0Z","content":"_2jwZj"};

var useIsomorphicLayoutEffect = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

var Collapsible = function Collapsible(_ref) {
  var children = _ref.children,
      open = _ref.open,
      onTransitionEnd = _ref.onTransitionEnd,
      onTransitionStart = _ref.onTransitionStart,
      _ref$revealType = _ref.revealType,
      revealType = _ref$revealType === void 0 ? 'bottomFirst' : _ref$revealType;

  var _React$useState = useState(false),
      isTransitioning = _React$useState[0],
      setIsTransitioning = _React$useState[1];

  useIsomorphicLayoutEffect(function () {
    return function () {
      if (onTransitionStart) {
        onTransitionStart(open);
      }

      setIsTransitioning(true);
    };
  }, [open]);
  var handleTransitionEnd = useCallback(function (event) {
    if (event.propertyName === 'grid-template-rows') {
      if (onTransitionEnd) {
        onTransitionEnd(open);
      }

      setIsTransitioning(false);
    }
  }, [open, onTransitionEnd]);
  var className = useMemo(function () {
    var classNames = [styles.wrapper, open ? styles.is_state_open : styles.is_state_closed, styles["is_revealType_" + revealType]];

    if (isTransitioning) {
      classNames.push(styles.is_transitioning);
    }

    return classNames.join(' ');
  }, [isTransitioning, open]);
  return createElement("div", {
    className: className,
    "aria-hidden": !open,
    onTransitionEnd: handleTransitionEnd
  }, createElement("div", {
    className: styles["in"]
  }, createElement("div", {
    className: styles.content
  }, children)));
};

export { Collapsible };
//# sourceMappingURL=index.modern.js.map
